export default __webpack_public_path__ + "static/media/tether.5b8d0b82.png";